import React, { useState, useEffect } from 'react';

const BookingAdmin = () => {
  const [slots, setSlots] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [newSlot, setNewSlot] = useState({ date: '', startTime: '10:00', endTime: '11:00' });
  const [message, setMessage] = useState('');
  const [activeTab, setActiveTab] = useState('slots');

  const fetchData = () => {
    fetch('/data/booking-slots.json?t=' + Date.now())
      .then((r) => r.ok ? r.json() : [])
      .then(setSlots)
      .catch(() => setSlots([]));
    fetch('/data/bookings.json?t=' + Date.now())
      .then((r) => r.ok ? r.json() : [])
      .then(setBookings)
      .catch(() => setBookings([]));
  };

  useEffect(() => { fetchData(); }, []);

  const saveSlots = async (data) => {
    await fetch('/api/admin-data.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ file: 'booking-slots', data }),
    });
    setSlots(data);
  };

  const saveBookings = async (data) => {
    await fetch('/api/admin-data.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ file: 'bookings', data }),
    });
    setBookings(data);
  };

  const addSlot = async () => {
    if (!newSlot.date || !newSlot.startTime || !newSlot.endTime) return;
    const slot = {
      id: Date.now(),
      date: newSlot.date,
      startTime: newSlot.startTime,
      endTime: newSlot.endTime,
      booked: false,
    };
    await saveSlots([...slots, slot]);
    setNewSlot({ date: '', startTime: '10:00', endTime: '11:00' });
    setMessage('枠を追加しました');
    setTimeout(() => setMessage(''), 2000);
  };

  const deleteSlot = async (id) => {
    if (!window.confirm('この枠を削除しますか？')) return;
    await saveSlots(slots.filter((s) => s.id !== id));
    setMessage('削除しました');
    setTimeout(() => setMessage(''), 2000);
  };

  const cancelBooking = async (id) => {
    if (!window.confirm('この予約をキャンセルしますか？')) return;
    const booking = bookings.find((b) => b.id === id);
    const updated = bookings.filter((b) => b.id !== id);
    await saveBookings(updated);
    // 枠を空きに戻す
    if (booking) {
      const updatedSlots = slots.map((s) =>
        s.id === booking.slotId ? { ...s, booked: false } : s
      );
      await saveSlots(updatedSlots);
    }
    setMessage('キャンセルしました');
    setTimeout(() => setMessage(''), 2000);
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const days = ['日', '月', '火', '水', '木', '金', '土'];
    return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}（${days[d.getDay()]}）`;
  };

  // 日付でソート
  const sortedSlots = [...slots].sort((a, b) => {
    const da = a.date + a.startTime;
    const db = b.date + b.startTime;
    return da.localeCompare(db);
  });

  const sortedBookings = [...bookings].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  const today = new Date().toISOString().split('T')[0];
  const futureSlots = sortedSlots.filter((s) => s.date >= today);
  const pastSlots = sortedSlots.filter((s) => s.date < today);

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">予約管理</h2>

      {message && <div className="mb-4 px-4 py-2 bg-green-100 text-green-800 rounded-lg text-sm">{message}</div>}

      {/* タブ */}
      <div className="flex gap-2 mb-6">
        <button
          onClick={() => setActiveTab('slots')}
          className={`px-4 py-2 rounded-lg text-sm font-bold ${activeTab === 'slots' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
        >
          空き枠管理
        </button>
        <button
          onClick={() => setActiveTab('bookings')}
          className={`px-4 py-2 rounded-lg text-sm font-bold ${activeTab === 'bookings' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
        >
          予約一覧 {bookings.length > 0 && `(${bookings.length})`}
        </button>
      </div>

      {activeTab === 'slots' && (
        <>
          {/* 枠追加 */}
          <div className="bg-white rounded-xl shadow p-6 mb-6">
            <h3 className="font-bold text-lg mb-4">空き枠を追加</h3>
            <div className="flex gap-3 items-end flex-wrap">
              <div>
                <label className="block text-sm font-bold mb-1">日付</label>
                <input
                  type="date"
                  value={newSlot.date}
                  min={today}
                  onChange={(e) => setNewSlot({ ...newSlot, date: e.target.value })}
                  className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-bold mb-1">開始</label>
                <input
                  type="time"
                  value={newSlot.startTime}
                  onChange={(e) => setNewSlot({ ...newSlot, startTime: e.target.value })}
                  className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-bold mb-1">終了</label>
                <input
                  type="time"
                  value={newSlot.endTime}
                  onChange={(e) => setNewSlot({ ...newSlot, endTime: e.target.value })}
                  className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <button
                onClick={addSlot}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg text-sm font-bold hover:bg-blue-700"
              >
                追加
              </button>
            </div>
          </div>

          {/* 枠一覧 */}
          <div className="bg-white rounded-xl shadow overflow-hidden">
            <div className="px-4 py-3 bg-gray-50 border-b text-xs text-gray-500 font-bold">
              今後の空き枠（{futureSlots.length}件）
            </div>
            {futureSlots.length === 0 ? (
              <div className="p-8 text-center text-gray-500">空き枠がありません</div>
            ) : (
              <div className="divide-y">
                {futureSlots.map((slot) => (
                  <div key={slot.id} className="px-4 py-3 flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <span className={`w-3 h-3 rounded-full ${slot.booked ? 'bg-red-400' : 'bg-green-400'}`} />
                      <div>
                        <p className="font-bold text-sm">{formatDate(slot.date)}</p>
                        <p className="text-xs text-gray-500">{slot.startTime} - {slot.endTime}</p>
                      </div>
                      {slot.booked && <span className="text-xs font-bold text-red-500 bg-red-50 px-2 py-0.5 rounded">予約済み</span>}
                    </div>
                    {!slot.booked && (
                      <button onClick={() => deleteSlot(slot.id)} className="bg-red-50 text-red-600 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-red-100">
                        削除
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {pastSlots.length > 0 && (
            <div className="mt-4 bg-white rounded-xl shadow overflow-hidden">
              <div className="px-4 py-3 bg-gray-50 border-b text-xs text-gray-500 font-bold">
                過去の枠（{pastSlots.length}件）
              </div>
              <div className="divide-y opacity-50">
                {pastSlots.map((slot) => (
                  <div key={slot.id} className="px-4 py-3 flex items-center gap-4">
                    <span className="w-3 h-3 rounded-full bg-gray-300" />
                    <div>
                      <p className="font-bold text-sm">{formatDate(slot.date)}</p>
                      <p className="text-xs text-gray-500">{slot.startTime} - {slot.endTime}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}

      {activeTab === 'bookings' && (
        <div className="bg-white rounded-xl shadow overflow-hidden">
          {sortedBookings.length === 0 ? (
            <div className="p-8 text-center text-gray-500">予約がありません</div>
          ) : (
            <div className="divide-y">
              {sortedBookings.map((booking) => (
                <div key={booking.id} className="px-4 py-4 flex items-center justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <p className="font-bold text-sm">{booking.name}</p>
                      <span className="text-xs text-gray-400">{booking.email}</span>
                    </div>
                    <p className="text-sm text-gray-700">
                      {formatDate(booking.date)} {booking.startTime} - {booking.endTime}
                    </p>
                    {booking.message && <p className="text-xs text-gray-500 mt-1">{booking.message}</p>}
                  </div>
                  <button onClick={() => cancelBooking(booking.id)} className="bg-red-50 text-red-600 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-red-100">
                    キャンセル
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BookingAdmin;
